import { render, staticRenderFns } from "./teacherBook.vue?vue&type=template&id=2a5588ac&scoped=true&"
import script from "./teacherBook.vue?vue&type=script&lang=js&"
export * from "./teacherBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5588ac",
  null
  
)

export default component.exports